import type { ListItem } from 'mdast';
import type { State } from '../state';

export function listItem(state: State, node: ListItem): void {
	const isTask = node.checked !== null && node.checked !== undefined;

	// If the schema has a dedicated taskItem node (ADF style), use it
	const taskItemType = state.schema.nodes.taskItem ?? state.schema.nodes.task_item;
	if (isTask && taskItemType) {
		const taskAttrs: Record<string, unknown> = {};
		const attrSpec = taskItemType.spec.attrs ?? {};
		if ('state' in attrSpec) {
			// ADF convention: state is 'DONE' or 'TODO'
			taskAttrs.state = node.checked ? 'DONE' : 'TODO';
		}
		if ('checked' in attrSpec) {
			taskAttrs.checked = node.checked;
		}

		state.openNode(taskItemType, taskAttrs);
		// taskItem has inline content, so flatten paragraph children
		for (const child of node.children) {
			if (child.type === 'paragraph') {
				state.parseTokens(child.children);
			} else {
				state.parseTokens([child]);
			}
		}
		state.closeNode();
		return;
	}

	// Regular list item (or task item falling back to list_item when no taskItem node)
	const itemType = state.schema.nodes.list_item ?? state.schema.nodes.listItem;
	if (!itemType) {
		// Gracefully degrade: schema has no list item node — render children directly
		state.parseTokens(node.children);
		return;
	}
	const attrs: Record<string, unknown> = {};
	if ('checked' in (itemType.spec.attrs ?? {})) {
		// Always write the checked attr when the schema supports it (null for non-task items)
		attrs.checked = isTask ? node.checked : null;
	}

	state.openNode(itemType, attrs);
	state.parseTokens(node.children);
	state.closeNode();
}
